import cxs from 'cxs';
import { COLOURS, FLATTENED_COLOURS } from '../../../common/styles/vars';

const MENU_TRANSITION = {
  transition: 'width .3s ease-in-out, min-width .3s ease-in-out'
};

export const MENU = (
primaryColour,
align,
width,
minimised,
{ hideBorder } = {}) =>
cxs({
  background: primaryColour ? FLATTENED_COLOURS[primaryColour] : COLOURS.mono.white,
  [align === 'left' ? 'borderRight' : 'borderLeft']: !hideBorder ? `1px solid ${COLOURS.grey.mischka.russian}` : void 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  boxSizing: 'border-box',
  ...MENU_TRANSITION,
  width: `${width}px`
});

export const MENU_CONTAINER = ({ width }) => cxs({
  height: '100%',
  width: `${width}px`,
  minWidth: `${width}px`,

  ':focus': {
    outline: '1px solid',
    outlineColor: 'inherit'
  },

  ...MENU_TRANSITION
});

export const MINIMISED_MENU = ({ minimisedWidth }) => cxs({
  width: `${minimisedWidth}px !important`,
  minWidth: `${minimisedWidth}px !important`
});